import PATHS from '@/router/paths'

const columns = {
  [PATHS.CUSTOM_REPORTS.BASE]: [],
}

export default columns
